import React from "react"
import { Navigate, Outlet } from "react-router-dom"
import { Stack } from "@mui/material"
import {
  AUTHENTICATED_ENTRY,
  PROFESSOR_AUTHENTICATED_ENTRY,
} from "configs/AppConfig"
import { useAuthContext } from "contexts/AuthContext"
import ContainerWrapper from "components/UI/ContainerWrapper"
import Header from "components/Auth/Header/Header"
import { USER_TYPES } from "common/constants"

const PublicRoutes = () => {
  const { userData, isConfigurationCompleted } = useAuthContext()
  // Professors have their own portal — send them there instead of to missions.
  if (userData?.userTypeId === USER_TYPES.TEACHER) {
    return <Navigate to={PROFESSOR_AUTHENTICATED_ENTRY} replace />
  }
  return userData !== null && userData?.userId > 0 ? (
    <Navigate
      to={
        isConfigurationCompleted
          ? AUTHENTICATED_ENTRY
          : "/account?firstSetup=1&welcomeMessage=1"
      }
    />
  ) : (
    <Stack sx={{ minHeight: "100dvh" }}>
      <ContainerWrapper>
        <Header />
        <Outlet />
      </ContainerWrapper>
    </Stack>
  )
}

export default PublicRoutes
